// This file is auto-generated by @hey-api/openapi-ts

import type { Options } from "@hey-api/client-fetch";
import {
  queryOptions,
  type UseMutationOptions,
  infiniteQueryOptions,
  type InfiniteData,
} from "@tanstack/react-query";
import {
  client,
  getHealth,
  getReady,
  postWebhooksSmartpark,
  getApiGames,
  postApiGames,
  patchApiGamesByGameId,
  getApiGamesByGameId,
  getApiGamesByGameIdFull,
  getApiGamesByGameIdPlateAppearances,
  getApiGamesByGameIdActivities,
  getApiGamesByGameIdActivitiesByActivityId,
  getApiGamesByGameIdActivitiesByActivityIdHitter,
  getApiActivitiesByActivityId,
  getApiActivitiesByActivityIdHitter,
  postApiActivitiesByActivityIdObservations,
  putApiActivitiesByActivityIdPlayers,
  getApiGamesByGameIdLineup,
  postApiGamesByGameIdLineup,
  putApiGamesByGameIdLineupBySide,
  postApiGamesByGameIdSubstitutions,
  postApiGamesByGameIdEnd,
  postApiGamesByGameIdUnend,
  postApiGamesByGameIdTeamSwap,
  postApiGamesByGameIdTeamsValidated,
  getApiMachine,
} from "../services.gen";
import type {
  PostWebhooksSmartparkData,
  PostWebhooksSmartparkError,
  PostWebhooksSmartparkResponse,
  GetApiGamesData,
  PostApiGamesData,
  PostApiGamesError,
  PostApiGamesResponse,
  PatchApiGamesByGameIdData,
  PatchApiGamesByGameIdError,
  PatchApiGamesByGameIdResponse,
  GetApiGamesByGameIdData,
  GetApiGamesByGameIdFullData,
  GetApiGamesByGameIdPlateAppearancesData,
  GetApiGamesByGameIdPlateAppearancesError,
  GetApiGamesByGameIdPlateAppearancesResponse,
  GetApiGamesByGameIdActivitiesData,
  GetApiGamesByGameIdActivitiesError,
  GetApiGamesByGameIdActivitiesResponse,
  GetApiGamesByGameIdActivitiesByActivityIdData,
  GetApiGamesByGameIdActivitiesByActivityIdHitterData,
  GetApiActivitiesByActivityIdData,
  GetApiActivitiesByActivityIdHitterData,
  PostApiActivitiesByActivityIdObservationsData,
  PostApiActivitiesByActivityIdObservationsError,
  PostApiActivitiesByActivityIdObservationsResponse,
  PutApiActivitiesByActivityIdPlayersData,
  PutApiActivitiesByActivityIdPlayersError,
  PutApiActivitiesByActivityIdPlayersResponse,
  GetApiGamesByGameIdLineupData,
  PostApiGamesByGameIdLineupData,
  PostApiGamesByGameIdLineupError,
  PostApiGamesByGameIdLineupResponse,
  PutApiGamesByGameIdLineupBySideData,
  PutApiGamesByGameIdLineupBySideError,
  PutApiGamesByGameIdLineupBySideResponse,
  PostApiGamesByGameIdSubstitutionsData,
  PostApiGamesByGameIdSubstitutionsError,
  PostApiGamesByGameIdSubstitutionsResponse,
  PostApiGamesByGameIdEndData,
  PostApiGamesByGameIdEndError,
  PostApiGamesByGameIdEndResponse,
  PostApiGamesByGameIdUnendData,
  PostApiGamesByGameIdUnendError,
  PostApiGamesByGameIdUnendResponse,
  PostApiGamesByGameIdTeamSwapData,
  PostApiGamesByGameIdTeamSwapError,
  PostApiGamesByGameIdTeamSwapResponse,
  PostApiGamesByGameIdTeamsValidatedData,
  PostApiGamesByGameIdTeamsValidatedError,
  PostApiGamesByGameIdTeamsValidatedResponse,
} from "../types.gen";

type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
): QueryKey<TOptions>[0] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return params;
};

export const getHealthQueryKey = (options?: Options) => [
  createQueryKey("getHealth", options),
];

export const getHealthOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHealth({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHealthQueryKey(options),
  });
};

export const getReadyQueryKey = (options?: Options) => [
  createQueryKey("getReady", options),
];

export const getReadyOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReady({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReadyQueryKey(options),
  });
};

export const postWebhooksSmartparkQueryKey = (
  options: Options<PostWebhooksSmartparkData>,
) => [createQueryKey("postWebhooksSmartpark", options)];

export const postWebhooksSmartparkOptions = (
  options: Options<PostWebhooksSmartparkData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postWebhooksSmartpark({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postWebhooksSmartparkQueryKey(options),
  });
};

export const postWebhooksSmartparkMutation = (
  options?: Partial<Options<PostWebhooksSmartparkData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostWebhooksSmartparkResponse,
    PostWebhooksSmartparkError,
    Options<PostWebhooksSmartparkData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postWebhooksSmartpark({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiGamesQueryKey = (options?: Options<GetApiGamesData>) => [
  createQueryKey("getApiGames", options),
];

export const getApiGamesOptions = (options?: Options<GetApiGamesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApiGames({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiGamesQueryKey(options),
  });
};

export const postApiGamesQueryKey = (options: Options<PostApiGamesData>) => [
  createQueryKey("postApiGames", options),
];

export const postApiGamesOptions = (options: Options<PostApiGamesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postApiGames({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postApiGamesQueryKey(options),
  });
};

export const postApiGamesMutation = (
  options?: Partial<Options<PostApiGamesData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostApiGamesResponse,
    PostApiGamesError,
    Options<PostApiGamesData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postApiGames({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const patchApiGamesByGameIdMutation = (
  options?: Partial<Options<PatchApiGamesByGameIdData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PatchApiGamesByGameIdResponse,
    PatchApiGamesByGameIdError,
    Options<PatchApiGamesByGameIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await patchApiGamesByGameId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiGamesByGameIdQueryKey = (
  options: Options<GetApiGamesByGameIdData>,
) => [createQueryKey("getApiGamesByGameId", options)];

export const getApiGamesByGameIdOptions = (
  options: Options<GetApiGamesByGameIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApiGamesByGameId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiGamesByGameIdQueryKey(options),
  });
};

export const getApiGamesByGameIdFullQueryKey = (
  options: Options<GetApiGamesByGameIdFullData>,
) => [createQueryKey("getApiGamesByGameIdFull", options)];

export const getApiGamesByGameIdFullOptions = (
  options: Options<GetApiGamesByGameIdFullData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApiGamesByGameIdFull({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiGamesByGameIdFullQueryKey(options),
  });
};

export const getApiGamesByGameIdPlateAppearancesQueryKey = (
  options: Options<GetApiGamesByGameIdPlateAppearancesData>,
) => [createQueryKey("getApiGamesByGameIdPlateAppearances", options)];

export const getApiGamesByGameIdPlateAppearancesOptions = (
  options: Options<GetApiGamesByGameIdPlateAppearancesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApiGamesByGameIdPlateAppearances({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiGamesByGameIdPlateAppearancesQueryKey(options),
  });
};

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">,
>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = queryKey[0];
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...queryKey[0].path,
      ...page.path,
    };
  }
  if (page.query) {
    params.query = {
      ...queryKey[0].query,
      ...page.query,
    };
  }
  return params as unknown as typeof page;
};

export const getApiGamesByGameIdPlateAppearancesInfiniteQueryKey = (
  options: Options<GetApiGamesByGameIdPlateAppearancesData>,
): QueryKey<Options<GetApiGamesByGameIdPlateAppearancesData>> => [
  createQueryKey("getApiGamesByGameIdPlateAppearances", options, true),
];

export const getApiGamesByGameIdPlateAppearancesInfiniteOptions = (
  options: Options<GetApiGamesByGameIdPlateAppearancesData>,
) => {
  return infiniteQueryOptions<
    GetApiGamesByGameIdPlateAppearancesResponse,
    GetApiGamesByGameIdPlateAppearancesError,
    InfiniteData<GetApiGamesByGameIdPlateAppearancesResponse>,
    QueryKey<Options<GetApiGamesByGameIdPlateAppearancesData>>,
    | string
    | Pick<
        QueryKey<Options<GetApiGamesByGameIdPlateAppearancesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiGamesByGameIdPlateAppearancesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiGamesByGameIdPlateAppearances({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiGamesByGameIdPlateAppearancesInfiniteQueryKey(options),
    },
  );
};

export const getApiGamesByGameIdActivitiesQueryKey = (
  options: Options<GetApiGamesByGameIdActivitiesData>,
) => [createQueryKey("getApiGamesByGameIdActivities", options)];

export const getApiGamesByGameIdActivitiesOptions = (
  options: Options<GetApiGamesByGameIdActivitiesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApiGamesByGameIdActivities({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiGamesByGameIdActivitiesQueryKey(options),
  });
};

export const getApiGamesByGameIdActivitiesInfiniteQueryKey = (
  options: Options<GetApiGamesByGameIdActivitiesData>,
): QueryKey<Options<GetApiGamesByGameIdActivitiesData>> => [
  createQueryKey("getApiGamesByGameIdActivities", options, true),
];

export const getApiGamesByGameIdActivitiesInfiniteOptions = (
  options: Options<GetApiGamesByGameIdActivitiesData>,
) => {
  return infiniteQueryOptions<
    GetApiGamesByGameIdActivitiesResponse,
    GetApiGamesByGameIdActivitiesError,
    InfiniteData<GetApiGamesByGameIdActivitiesResponse>,
    QueryKey<Options<GetApiGamesByGameIdActivitiesData>>,
    | string
    | Pick<
        QueryKey<Options<GetApiGamesByGameIdActivitiesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiGamesByGameIdActivitiesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiGamesByGameIdActivities({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiGamesByGameIdActivitiesInfiniteQueryKey(options),
    },
  );
};

export const getApiGamesByGameIdActivitiesByActivityIdQueryKey = (
  options: Options<GetApiGamesByGameIdActivitiesByActivityIdData>,
) => [createQueryKey("getApiGamesByGameIdActivitiesByActivityId", options)];

export const getApiGamesByGameIdActivitiesByActivityIdOptions = (
  options: Options<GetApiGamesByGameIdActivitiesByActivityIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApiGamesByGameIdActivitiesByActivityId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiGamesByGameIdActivitiesByActivityIdQueryKey(options),
  });
};

export const getApiGamesByGameIdActivitiesByActivityIdHitterQueryKey = (
  options: Options<GetApiGamesByGameIdActivitiesByActivityIdHitterData>,
) => [
  createQueryKey("getApiGamesByGameIdActivitiesByActivityIdHitter", options),
];

export const getApiGamesByGameIdActivitiesByActivityIdHitterOptions = (
  options: Options<GetApiGamesByGameIdActivitiesByActivityIdHitterData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApiGamesByGameIdActivitiesByActivityIdHitter({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiGamesByGameIdActivitiesByActivityIdHitterQueryKey(options),
  });
};

export const getApiActivitiesByActivityIdQueryKey = (
  options: Options<GetApiActivitiesByActivityIdData>,
) => [createQueryKey("getApiActivitiesByActivityId", options)];

export const getApiActivitiesByActivityIdOptions = (
  options: Options<GetApiActivitiesByActivityIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApiActivitiesByActivityId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiActivitiesByActivityIdQueryKey(options),
  });
};

export const getApiActivitiesByActivityIdHitterQueryKey = (
  options: Options<GetApiActivitiesByActivityIdHitterData>,
) => [createQueryKey("getApiActivitiesByActivityIdHitter", options)];

export const getApiActivitiesByActivityIdHitterOptions = (
  options: Options<GetApiActivitiesByActivityIdHitterData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApiActivitiesByActivityIdHitter({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiActivitiesByActivityIdHitterQueryKey(options),
  });
};

export const postApiActivitiesByActivityIdObservationsQueryKey = (
  options: Options<PostApiActivitiesByActivityIdObservationsData>,
) => [createQueryKey("postApiActivitiesByActivityIdObservations", options)];

export const postApiActivitiesByActivityIdObservationsOptions = (
  options: Options<PostApiActivitiesByActivityIdObservationsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postApiActivitiesByActivityIdObservations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postApiActivitiesByActivityIdObservationsQueryKey(options),
  });
};

export const postApiActivitiesByActivityIdObservationsMutation = (
  options?: Partial<Options<PostApiActivitiesByActivityIdObservationsData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostApiActivitiesByActivityIdObservationsResponse,
    PostApiActivitiesByActivityIdObservationsError,
    Options<PostApiActivitiesByActivityIdObservationsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postApiActivitiesByActivityIdObservations({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const putApiActivitiesByActivityIdPlayersMutation = (
  options?: Partial<Options<PutApiActivitiesByActivityIdPlayersData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PutApiActivitiesByActivityIdPlayersResponse,
    PutApiActivitiesByActivityIdPlayersError,
    Options<PutApiActivitiesByActivityIdPlayersData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putApiActivitiesByActivityIdPlayers({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiGamesByGameIdLineupQueryKey = (
  options: Options<GetApiGamesByGameIdLineupData>,
) => [createQueryKey("getApiGamesByGameIdLineup", options)];

export const getApiGamesByGameIdLineupOptions = (
  options: Options<GetApiGamesByGameIdLineupData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApiGamesByGameIdLineup({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiGamesByGameIdLineupQueryKey(options),
  });
};

export const postApiGamesByGameIdLineupQueryKey = (
  options: Options<PostApiGamesByGameIdLineupData>,
) => [createQueryKey("postApiGamesByGameIdLineup", options)];

export const postApiGamesByGameIdLineupOptions = (
  options: Options<PostApiGamesByGameIdLineupData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postApiGamesByGameIdLineup({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postApiGamesByGameIdLineupQueryKey(options),
  });
};

export const postApiGamesByGameIdLineupMutation = (
  options?: Partial<Options<PostApiGamesByGameIdLineupData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostApiGamesByGameIdLineupResponse,
    PostApiGamesByGameIdLineupError,
    Options<PostApiGamesByGameIdLineupData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postApiGamesByGameIdLineup({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const putApiGamesByGameIdLineupBySideMutation = (
  options?: Partial<Options<PutApiGamesByGameIdLineupBySideData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PutApiGamesByGameIdLineupBySideResponse,
    PutApiGamesByGameIdLineupBySideError,
    Options<PutApiGamesByGameIdLineupBySideData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await putApiGamesByGameIdLineupBySide({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postApiGamesByGameIdSubstitutionsQueryKey = (
  options: Options<PostApiGamesByGameIdSubstitutionsData>,
) => [createQueryKey("postApiGamesByGameIdSubstitutions", options)];

export const postApiGamesByGameIdSubstitutionsOptions = (
  options: Options<PostApiGamesByGameIdSubstitutionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postApiGamesByGameIdSubstitutions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postApiGamesByGameIdSubstitutionsQueryKey(options),
  });
};

export const postApiGamesByGameIdSubstitutionsMutation = (
  options?: Partial<Options<PostApiGamesByGameIdSubstitutionsData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostApiGamesByGameIdSubstitutionsResponse,
    PostApiGamesByGameIdSubstitutionsError,
    Options<PostApiGamesByGameIdSubstitutionsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postApiGamesByGameIdSubstitutions({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postApiGamesByGameIdEndQueryKey = (
  options: Options<PostApiGamesByGameIdEndData>,
) => [createQueryKey("postApiGamesByGameIdEnd", options)];

export const postApiGamesByGameIdEndOptions = (
  options: Options<PostApiGamesByGameIdEndData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postApiGamesByGameIdEnd({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postApiGamesByGameIdEndQueryKey(options),
  });
};

export const postApiGamesByGameIdEndMutation = (
  options?: Partial<Options<PostApiGamesByGameIdEndData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostApiGamesByGameIdEndResponse,
    PostApiGamesByGameIdEndError,
    Options<PostApiGamesByGameIdEndData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postApiGamesByGameIdEnd({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postApiGamesByGameIdUnendQueryKey = (
  options: Options<PostApiGamesByGameIdUnendData>,
) => [createQueryKey("postApiGamesByGameIdUnend", options)];

export const postApiGamesByGameIdUnendOptions = (
  options: Options<PostApiGamesByGameIdUnendData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postApiGamesByGameIdUnend({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postApiGamesByGameIdUnendQueryKey(options),
  });
};

export const postApiGamesByGameIdUnendMutation = (
  options?: Partial<Options<PostApiGamesByGameIdUnendData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostApiGamesByGameIdUnendResponse,
    PostApiGamesByGameIdUnendError,
    Options<PostApiGamesByGameIdUnendData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postApiGamesByGameIdUnend({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postApiGamesByGameIdTeamSwapQueryKey = (
  options: Options<PostApiGamesByGameIdTeamSwapData>,
) => [createQueryKey("postApiGamesByGameIdTeamSwap", options)];

export const postApiGamesByGameIdTeamSwapOptions = (
  options: Options<PostApiGamesByGameIdTeamSwapData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postApiGamesByGameIdTeamSwap({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postApiGamesByGameIdTeamSwapQueryKey(options),
  });
};

export const postApiGamesByGameIdTeamSwapMutation = (
  options?: Partial<Options<PostApiGamesByGameIdTeamSwapData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostApiGamesByGameIdTeamSwapResponse,
    PostApiGamesByGameIdTeamSwapError,
    Options<PostApiGamesByGameIdTeamSwapData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postApiGamesByGameIdTeamSwap({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postApiGamesByGameIdTeamsValidatedQueryKey = (
  options: Options<PostApiGamesByGameIdTeamsValidatedData>,
) => [createQueryKey("postApiGamesByGameIdTeamsValidated", options)];

export const postApiGamesByGameIdTeamsValidatedOptions = (
  options: Options<PostApiGamesByGameIdTeamsValidatedData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postApiGamesByGameIdTeamsValidated({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postApiGamesByGameIdTeamsValidatedQueryKey(options),
  });
};

export const postApiGamesByGameIdTeamsValidatedMutation = (
  options?: Partial<Options<PostApiGamesByGameIdTeamsValidatedData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostApiGamesByGameIdTeamsValidatedResponse,
    PostApiGamesByGameIdTeamsValidatedError,
    Options<PostApiGamesByGameIdTeamsValidatedData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postApiGamesByGameIdTeamsValidated({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiMachineQueryKey = (options?: Options) => [
  createQueryKey("getApiMachine", options),
];

export const getApiMachineOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApiMachine({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiMachineQueryKey(options),
  });
};
